import React from "react";
import { NavLink } from "react-router-dom";
import "./BottomNav.css"; // make sure you have the CSS file

export default function BottomNav() {
  return (
    <nav className="bottom-nav">
      <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>
        <span className="icon">🏠</span>
        <span>HOME</span>
      </NavLink>

      <NavLink
        to="/play"
        className={({ isActive }) => (isActive ? "active" : "")}
      >
        <span className="icon">▶️</span>
        <span>Start</span>
      </NavLink>

      <NavLink
        to="/wallet"
        className={({ isActive }) => (isActive ? "active" : "")}
      >
        <span className="icon">💳</span>
        <span>WALLET</span>
      </NavLink>
    </nav>
  );
}
